var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.screeningTitle,
        visible: true,
        centered: "",
        "header-bg-variant": "success",
        "header-text-variant": "light"
      },
      on: { hide: _vm.closeModal, ok: _vm.updateOldTraffickingScreening },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "secondary",
                    size: "sm",
                    disabled: _vm.isLoading
                  },
                  on: { click: _vm.closeModal }
                },
                [_vm._v("\n            Cancel\n        ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "primary",
                    size: "sm",
                    disabled: _vm.isLoading
                  },
                  on: { click: _vm.updateOldTraffickingScreening }
                },
                [
                  _vm.isLoading
                    ? _c("i", { staticClass: "fa fa-spinner" })
                    : _c("span", [
                        _vm._v("\n                Update\n            ")
                      ])
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("div", [
                _c("b", [
                  _vm._v(
                    "\n                    Screening Results\n                "
                  )
                ])
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.screeningConclusion) +
                  "\n            "
              ),
              _c("p", { staticClass: "mt-3" }, [
                _c("b", [
                  _vm._v(
                    "\n                    If available, upload PDF copy of the Louisiana Indicator Tool for Child & Youth Sex Trafficking by clicking on the button below.\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              !_vm.screening.fileName || _vm.isFileDeleted
                ? _c("div", [
                    _c(
                      "label",
                      {
                        staticClass: "custom-file-upload",
                        attrs: { for: "file-upload" }
                      },
                      [
                        _vm._v(
                          "\n                    Upload PDF\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.updatedScreening.fileName))]),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        disabled: _vm.isLoading,
                        type: "file",
                        id: "file-upload"
                      },
                      on: { change: _vm.onFileUpload }
                    })
                  ])
                : _c(
                    "div",
                    [
                      _vm.downloadLink
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.downloadLink,
                                  download: _vm.screening.fileName
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.screening.fileName) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "clear-btn",
                                on: { click: _vm.deleteScreeningFile }
                              },
                              [_c("i", { staticClass: "icon-trash" })]
                            )
                          ])
                        : _c("pulse-loader", {
                            attrs: { color: "#0F347B", size: "20px" }
                          })
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("p", { staticClass: "mt-3" }, [_c("b", [_vm._v("Comments")])]),
              _vm._v(" "),
              _c("b-form-textarea", {
                staticClass: "mt-3",
                attrs: {
                  rows: "10",
                  placeholder: "Enter Comments",
                  name: "comments"
                },
                model: {
                  value: _vm.updatedScreening.comments,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedScreening, "comments", $$v)
                  },
                  expression: "updatedScreening.comments"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "mt-3", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", [
                    _c("p", { staticClass: "card-text" }, [
                      _c(
                        "small",
                        {
                          staticClass:
                            "text-muted text-uppercase font-weight-bold"
                        },
                        [_vm._v("First Recorded")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _c("b", [_vm._v(" on: ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("unixToHuman")(
                                _vm.screening.createdAt / 1000
                              )
                            ) +
                            "\n                        "
                        ),
                        _vm._.isObject(_vm.screening.createdBy)
                          ? _c("div", [
                              _c("b", [_vm._v(" by: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.screening,
                                      "createdBy.emailAddress",
                                      ""
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text" }, [
                      _c(
                        "small",
                        {
                          staticClass:
                            "text-muted text-uppercase font-weight-bold"
                        },
                        [_vm._v("Last Updated")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _c("b", [_vm._v(" on: ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("unixToHuman")(
                                _vm.screening.updatedAt / 1000
                              )
                            ) +
                            "\n                        "
                        ),
                        _vm._.isObject(_vm.screening.updatedBy)
                          ? _c("div", [
                              _c("b", [_vm._v(" by: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.screening,
                                      "updatedBy.emailAddress",
                                      ""
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text" }, [
                      _c(
                        "small",
                        {
                          staticClass:
                            "text-muted text-uppercase font-weight-bold"
                        },
                        [_vm._v("Current Record Owner")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _c("b", [_vm._v(" by: ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._.get(
                                _vm.screening,
                                "organizationOwner.title"
                              )
                            ) +
                            " "
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            fade: "",
            show:
              _vm.updateOldTraffickingScreeningError ||
              _vm.updateOldTraffickingScreeningSuccess ||
              _vm.downloadOldTraffickingScreeningError,
            variant: _vm.updateOldTraffickingScreeningSuccess
              ? "success"
              : "danger"
          }
        },
        [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.apiResponseMessage) }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90d3891e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90d3891e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/ViewOldTraffickingScreeningModal.vue
// module id = 1636
// module chunks = 0